// removed by extract-text-webpack-plugin
module.exports = {"root":"_2iA2cJD","svg":"_3on0Y4c"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/icon.less
 ** module id = 631
 ** module chunks = 0
 **/